import styled from '@emotion/styled';
import { Button, Heading3, SmallText2 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconCart from '@/assets/icons/icon-cart.svg';
import IconExclamation from '@/assets/icons/icon-exclamation.svg';
import { Icon } from '@/components';

export function NotFoundProduct() {
  const { REACT_APP_LINK_CLIENT_URL } = process.env;
  const onClickBack = () => {
    window.history.back();
  };

  const onClickMain = () => {
    window.location.href = `${REACT_APP_LINK_CLIENT_URL}/customer/menu`;
  };

  const onClickCart = () => window.location.replace('/cart');

  const onRouteMenu = () => (window.location.href = `${REACT_APP_LINK_CLIENT_URL}/customer/login`);

  return (
    <div className="container">
      <NavWrapper>
        <Container>
          <Right>
            <BtnCartContainer onClick={onClickCart}>
              <BtnCart />
              <CartCount>
                <SmallText2 className="text-white">2</SmallText2>
              </CartCount>
            </BtnCartContainer>
            <Icon sx={{ marginTop: '2px' }} icon="Menu" size={12} onClick={onRouteMenu} />
          </Right>
        </Container>
      </NavWrapper>
      <NotFound>
        <i className="empty-icon" />
        <Heading3 color="gray400">상품을 찾을 수 없습니다</Heading3>
        <div className="button-container">
          <Button size="large" style={{ width: '125px' }} onClick={onClickBack}>
            이전 페이지
          </Button>
          <Button size="large" type="primary" style={{ width: '125px' }} onClick={onClickMain}>
            메인 화면으로
          </Button>
        </div>
      </NotFound>
    </div>
  );
}

const NotFound = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  align-items: center;
  padding: 200px 0;

  .empty-icon {
    width: 69px;
    height: 69px;
    background-image: url(${IconExclamation});
    background-size: cover;
  }

  .button-container {
    display: flex;
    gap: 10px;
    width: 320px;

    button {
      flex: 1;
    }
  }
`;

const NavWrapper = styled.nav`
  position: relative;
  padding: -1px 10px;
  margin: 0 auto;
  width: 100%;
`;

const Container = styled.div`
  position: fixed;
  width: 100%;
  max-width: inherit;
  height: 50px;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 4px 4px;
  z-index: 999;
  top: 0;
  transition: transform 0.3s ease-in-out;
  background-color: white;

  &.hidden {
    transform: translateY(-100%);
  }

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: 12px;
`;

const BtnCartContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const BtnCart = styled.div`
  padding: 8px;
  cursor: pointer;
  background-image: url(${IconCart});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 17px;
  height: 22px;
`;

const CartCount = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${colors.orange800};
  right: -8px;
  top: -4px;
  display: flex;
  justify-content: center;
`;
